// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/task.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { InsightRecommendation } from "./insights";
import { PolicyInstance } from "../../policy/v1/policy";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Form } from "../../form/v1/form";
import { User } from "../../user/v1/user";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { Duration } from "../../../../google/protobuf/duration";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Struct } from "../../../../google/protobuf/struct";
import { Any } from "../../../../google/protobuf/any";
/**
 * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a request where the expand mask is part of the input. Use '*' to view all possible responses.
 *
 * @generated from protobuf message c1.api.task.v1.TaskExpandMask
 */
export interface TaskExpandMask {
    /**
     * A list of paths to expand in the response. May be any combination of "*", "access_review_id", "user_id", "created_by_user_id", "app_id", "app_user_id", "app_entitlement_ids", "step_approver_ids", "identity_user_id", "insight_ids", and "app_user_last_usage".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetRequest
 */
export interface TaskServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 2;
     */
    expandMask?: TaskExpandMask;
}
/**
 * The TaskServiceGetResponse returns a task view which has a task including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetResponse
 */
export interface TaskServiceGetResponse {
    /**
     * A view of the task, contains the serialized task and paths to objects referenced by the task
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The TaskServiceCreateGrantResponse returns a task view which has a task including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateGrantResponse
 */
export interface TaskServiceCreateGrantResponse {
    /**
     * A view of the task, of TaskTypeGrant, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The TaskServiceCreateRevokeResponse returns a task view which has a task including JSONPATHs to the expanded items in the expanded array.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateRevokeResponse
 */
export interface TaskServiceCreateRevokeResponse {
    /**
     * A view of the task, of TaskTypeRevoke, contains the serialized task and paths to objects referenced by the task.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateOffboardingResponse
 */
export interface TaskServiceCreateOffboardingResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateActionRequest
 */
export interface TaskServiceCreateActionRequest {
    /**
     * @generated from protobuf field: string action_id = 1;
     */
    actionId: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct form_values = 3;
     */
    formValues?: Struct;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 4;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateActionResponse
 */
export interface TaskServiceCreateActionResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceListRequest
 */
export interface TaskServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceListResponse
 */
export interface TaskServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1;
     */
    list: TaskView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceUpdateRequest
 */
export interface TaskServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.task.v1.Task task = 1;
     */
    task?: Task;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3;
     */
    expandMask?: TaskExpandMask;
}
/**
 * Create a revoke task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateRevokeRequest
 */
export interface TaskServiceCreateRevokeRequest {
    /**
     * The ID of the app associated with the entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app entitlement to revoke access to.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The ID of the user associated with the app user we are revoking access from. This field cannot be set if appUserID is also set.
     *
     * @generated from protobuf field: string identity_user_id = 6;
     */
    identityUserId: string;
    /**
     * The ID of the app user to revoke access from. This field and identityUserId cannot both be set for a given request.
     *
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * The description of the request.
     *
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a request where
     * the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 5;
     */
    expandMask?: TaskExpandMask;
}
/**
 * Create a grant task.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateGrantRequest
 */
export interface TaskServiceCreateGrantRequest {
    /**
     * The ID of the app that is associated with the entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app entitlement to grant access to.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The ID of the user associated with the app user we are granting access for. This field cannot be set if appUserID is also set.
     *
     * @generated from protobuf field: string identity_user_id = 3;
     */
    identityUserId: string;
    /**
     * The ID of the app user to grant access for. This field and identityUserId cannot both be set for a given request.
     *
     * @generated from protobuf field: string app_user_id = 7;
     */
    appUserId: string;
    /**
     * The description of the request.
     *
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * The duration of the grant.
     *
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 5;
     */
    grantDuration?: Duration;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 6;
     */
    expandMask?: TaskExpandMask;
    /**
     * Boolean stating whether or not the task is marked as emergency access.
     *
     * @generated from protobuf field: bool emergency_access = 8;
     */
    emergencyAccess: boolean;
    /**
     * The source of the grant
     *
     * @generated from protobuf field: c1.api.task.v1.TaskGrantSource source = 9;
     */
    source?: TaskGrantSource;
    /**
     * request schema data provided by the user
     *
     * @generated from protobuf field: google.protobuf.Struct request_data = 10;
     */
    requestData?: Struct;
}
/**
 * Create multiple grant tasks.
 *
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest
 */
export interface TaskServiceCreateManyGrantTasksRequest {
    /**
     * The ID of the app that is associated with the entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The IDs of the app entitlement(s) to grant access to.
     *
     * @generated from protobuf field: repeated string app_entitlement_ids = 2;
     */
    appEntitlementIds: string[];
    /**
     * The ID of the user associated with the app user we are granting access for. This field cannot be set if appUserID is also set.
     *
     * @generated from protobuf field: string identity_user_id = 3;
     */
    identityUserId: string;
    /**
     * The description of the request.
     *
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * The duration of the grant.
     *
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 5;
     */
    grantDuration?: Duration;
    /**
     * The task expand mask is an array of strings that specifes the related objects the requester wishes to have returned when making a
     * request where the expand mask is part of the input. Use '*' to view all possible responses.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 6;
     */
    expandMask?: TaskExpandMask;
    /**
     * The ID of the app user to grant access for. This field and identityUserId cannot both be set for a given request.
     *
     * @generated from protobuf field: string app_user_id = 7;
     */
    appUserId: string;
    /**
     * The source of the grant.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskGrantSource source = 8;
     */
    source?: TaskGrantSource;
    /**
     * References to the app entitlements to grant access to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 9;
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * Request schema data provided by the user
     *
     * @generated from protobuf field: google.protobuf.Struct request_data = 10;
     */
    requestData?: Struct;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateOffboardingRequest
 */
export interface TaskServiceCreateOffboardingRequest {
    /**
     * @generated from protobuf field: string subject_user_id = 1;
     */
    subjectUserId: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3;
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceCreateRequest
 */
export interface TaskServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskType typ = 5;
     */
    typ?: TaskType;
    /**
     * @generated from protobuf field: string description = 6;
     */
    description: string;
    /**
     * @generated from protobuf field: string user_id = 7;
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 9;
     */
    expandMask?: TaskExpandMask;
    /**
     * @generated from protobuf field: bool emergency_access = 10;
     */
    emergencyAccess: boolean;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceDeleteRequest
 */
export interface TaskServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskApprovers
 */
export interface TaskApprovers {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User users = 1;
     */
    users: User[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest
 */
export interface TaskServiceGetSendReminderPreviewRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse
 */
export interface TaskServiceGetSendReminderPreviewResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskApprovers task_approvers = 1;
     */
    taskApprovers?: TaskApprovers;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceSendReminderRequest
 */
export interface TaskServiceSendReminderRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * @generated from protobuf field: bool copy_managers = 2;
     */
    copyManagers: boolean;
    /**
     * @generated from protobuf field: string message = 3;
     */
    message: string;
    /**
     * @generated from protobuf field: repeated string copied_user_ids = 4;
     */
    copiedUserIds: string[];
}
/**
 * Request/Response messages for ResolvedFormDataService
 *
 * @generated from protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest
 */
export interface ResolvedFormDataServiceGetByTaskIdRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse
 */
export interface ResolvedFormDataServiceGetByTaskIdResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.ResolvedFormData resolved_form_data = 1;
     */
    resolvedFormData?: ResolvedFormData;
}
/**
 * ResolvedFormData contains the form schema and resolved values for a task.
 *
 * @generated from protobuf message c1.api.task.v1.ResolvedFormData
 */
export interface ResolvedFormData {
    /**
     * The form schema captured at submission time.
     *
     * @generated from protobuf field: c1.api.form.v1.Form form = 1;
     */
    form?: Form;
    /**
     * Resolved values computed at submission time, used for both execution and display.
     *
     * @generated from protobuf field: google.protobuf.Struct resolved_values = 2;
     */
    resolvedValues?: Struct;
    /**
     * Timestamp when the resolved form data was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * Timestamp when the resolved form data was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * Timestamp when the resolved form data was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceSendReminderResponse
 */
export interface TaskServiceSendReminderResponse {
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskServiceDeleteResponse
 */
export interface TaskServiceDeleteResponse {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
}
/**
 * Task Type provides configuration for the type of task: certify, grant, or revoke
 *
 * @generated from protobuf message c1.api.task.v1.TaskType
 */
export interface TaskType {
    /**
     * @generated from protobuf oneof: task_type
     */
    taskType: {
        oneofKind: "grant";
        /**
         * A sub-object indicating the ticket is of type Grant. Mutually exclusive with certify and revoke properties.
         *
         * @generated from protobuf field: c1.api.task.v1.TaskTypeGrant grant = 1;
         */
        grant: TaskTypeGrant;
    } | {
        oneofKind: "revoke";
        /**
         * A sub-object indicating the ticket is of type Revoke. Mutually exclusive with certify and grant properties.
         *
         * @generated from protobuf field: c1.api.task.v1.TaskTypeRevoke revoke = 2;
         */
        revoke: TaskTypeRevoke;
    } | {
        oneofKind: "certify";
        /**
         * A sub-object indicating the ticket is of type Certify. Mutually exclusive with grant and revoke properties.
         *
         * @generated from protobuf field: c1.api.task.v1.TaskTypeCertify certify = 3;
         */
        certify: TaskTypeCertify;
    } | {
        oneofKind: "offboarding";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskTypeOffboarding offboarding = 4;
         */
        offboarding: TaskTypeOffboarding;
    } | {
        oneofKind: "action";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskTypeAction action = 5;
         */
        action: TaskTypeAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskTypeAction
 */
export interface TaskTypeAction {
    /**
     * The ID of the action to execute.
     *
     * @generated from protobuf field: string action_id = 1;
     */
    actionId: string;
    /**
     * The form values for the action execution.
     *
     * @generated from protobuf field: google.protobuf.Struct form_values = 2;
     */
    formValues?: Struct;
    /**
     * @generated from protobuf field: c1.api.task.v1.ActionOutcome outcome = 3;
     */
    outcome: ActionOutcome;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 4;
     */
    outcomeTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskTypeOffboarding
 */
export interface TaskTypeOffboarding {
    /**
     * @generated from protobuf field: string subject_user_id = 1;
     */
    subjectUserId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.OffboardingOutcome outcome = 2;
     */
    outcome: OffboardingOutcome;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 3;
     */
    outcomeTime?: Timestamp;
}
/**
 * The TaskTypeGrant message indicates that a task is a grant task and all related details.
 *
 * @generated from protobuf message c1.api.task.v1.TaskTypeGrant
 */
export interface TaskTypeGrant {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * The ID of the app entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * The duration of the grant.
     *
     * @generated from protobuf field: google.protobuf.Duration grant_duration = 4;
     */
    grantDuration?: Duration;
    /**
     * The outcome of the grant.
     *
     * @generated from protobuf field: c1.api.task.v1.GrantOutcome outcome = 5;
     */
    outcome: GrantOutcome;
    /**
     * The time of the outcome of the grant.
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 6;
     */
    outcomeTime?: Timestamp;
    /**
     * The ID of the user.
     *
     * @generated from protobuf field: string identity_user_id = 7;
     */
    identityUserId: string;
    /**
     * The source of the grant.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskGrantSource source = 8;
     */
    source?: TaskGrantSource;
}
/**
 * The TaskGrantSource message tracks which external URL was the source of the specificed grant ticket.
 *
 * @generated from protobuf message c1.api.task.v1.TaskGrantSource
 */
export interface TaskGrantSource {
    /**
     * The integration id for the source of tickets.
     *
     * @generated from protobuf field: string integration_id = 1;
     */
    integrationId: string;
    /**
     * The external url source of the grant ticket.
     *
     * @generated from protobuf field: string external_url = 2;
     */
    externalUrl: string;
    /**
     * the request id for the grant ticket if the source is external
     *
     * @generated from protobuf field: string request_id = 3;
     */
    requestId: string;
    /**
     * The ID of the conversation that created this ticket
     *
     * @generated from protobuf field: string conversation_id = 4;
     */
    conversationId: string;
    /**
     * Whether the grant task is an extension task.
     *
     * @generated from protobuf field: bool is_extension = 5;
     */
    isExtension: boolean;
}
/**
 * The TaskRevokeSourceReview message tracks which access review was the source of the specificed revoke ticket.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceReview
 */
export interface TaskRevokeSourceReview {
    /**
     * The ID of the access review associated with the revoke task.
     *
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * The ID of the certify ticket that was denied and created this revoke task.
     *
     * @generated from protobuf field: string cert_ticket_id = 2;
     */
    certTicketId: string;
}
/**
 * The TaskRevokeSourceRequest message indicates that the source of the revoke task was a request.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceRequest
 */
export interface TaskRevokeSourceRequest {
    /**
     * The ID of the user who initiated the revoke request.
     *
     * @generated from protobuf field: string request_user_id = 1;
     */
    requestUserId: string;
}
/**
 * The TaskRevokeSourceExpired message indicates that the source of the revoke task is due to a grant expiring.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceExpired
 */
export interface TaskRevokeSourceExpired {
    /**
     * The timestamp indicates when the grant expired, automatically creating this revoke task.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expired_at = 1;
     */
    expiredAt?: Timestamp;
}
/**
 * The TaskRevokeSourceNonUsage message indicates that the source of the revoke task is due to the grant not being used.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSourceNonUsage
 */
export interface TaskRevokeSourceNonUsage {
    /**
     * The timestamp indicates when the revoke task will automatically happen.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 1;
     */
    expiresAt?: Timestamp;
    /**
     * The timestamp of the user's last login, due to non usage this task was automatically created
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_login = 2;
     */
    lastLogin?: Timestamp;
}
/**
 * The TaskRevokeSource message indicates the source of the revoke task is one of expired, nonUsage, request, or review.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRevokeSource
 */
export interface TaskRevokeSource {
    /**
     * @generated from protobuf oneof: origin
     */
    origin: {
        oneofKind: "review";
        /**
         * Source of the revoke is a review
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceReview review = 1;
         */
        review: TaskRevokeSourceReview;
    } | {
        oneofKind: "request";
        /**
         * Source of the revoke is a request
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceRequest request = 2;
         */
        request: TaskRevokeSourceRequest;
    } | {
        oneofKind: "expired";
        /**
         * Source of the revoke is the grant has expired (auto created)
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceExpired expired = 3;
         */
        expired: TaskRevokeSourceExpired;
    } | {
        oneofKind: "nonUsage";
        /**
         * Source of the revoke is due to inactivity (auto created due to user inactivity)
         *
         * @generated from protobuf field: c1.api.task.v1.TaskRevokeSourceNonUsage non_usage = 4;
         */
        nonUsage: TaskRevokeSourceNonUsage;
    } | {
        oneofKind: undefined;
    };
}
/**
 * The TaskTypeRevoke message indicates that a task is a revoke task and all related details.
 *
 * @generated from protobuf message c1.api.task.v1.TaskTypeRevoke
 */
export interface TaskTypeRevoke {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 5;
     */
    appUserId: string;
    /**
     * The ID of the app entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The outcome of the revoke.
     *
     * @generated from protobuf field: c1.api.task.v1.RevokeOutcome outcome = 3;
     */
    outcome: RevokeOutcome;
    /**
     * The time (in RFC3339 format) of the outcome of the revoke
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 4;
     */
    outcomeTime?: Timestamp;
    /**
     * The ID of the user.
     *
     * @generated from protobuf field: string identity_user_id = 6;
     */
    identityUserId: string;
    /**
     * The source of the revoke.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskRevokeSource source = 7;
     */
    source?: TaskRevokeSource;
}
/**
 * The TaskTypeCertify message indicates that a task is a certify task and all related details.
 *
 * @generated from protobuf message c1.api.task.v1.TaskTypeCertify
 */
export interface TaskTypeCertify {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The ID of the access review.
     *
     * @generated from protobuf field: string access_review_id = 3;
     */
    accessReviewId: string;
    /**
     * The ID of the specific access review object that owns this certify task. This is also set on a revoke task if the revoke task is created from the denied outcome of a certify task.
     *
     * @generated from protobuf field: string access_review_selection = 4;
     */
    accessReviewSelection: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 5;
     */
    appUserId: string;
    /**
     * The outcome of the certification.
     *
     * @generated from protobuf field: c1.api.task.v1.CertifyOutcome outcome = 6;
     */
    outcome: CertifyOutcome;
    /**
     * The timestamp indicating when the certification outcome occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 7;
     */
    outcomeTime?: Timestamp;
    /**
     * The ID of the user.
     *
     * @generated from protobuf field: string identity_user_id = 8;
     */
    identityUserId: string;
}
/**
 * A reference to an external source. This value is unused currently, but may be brought back.
 *
 * @generated from protobuf message c1.api.task.v1.ExternalRef
 */
export interface ExternalRef {
    /**
     * The URL to the external reference.
     *
     * @generated from protobuf field: string url = 1;
     */
    url: string;
    /**
     * The name of the external reference.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * The source of the external reference.
     *
     * @generated from protobuf field: c1.api.task.v1.ExternalRefSource external_ref_source = 3;
     */
    externalRefSource: ExternalRefSource;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskWebhookPayload
 */
export interface TaskWebhookPayload {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task_view = 1;
     */
    taskView?: TaskView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * Contains a task and JSONPATH expressions that describe where in the expanded array related objects are located. This view can be used to display a fully-detailed dashboard of task information.
 *
 * @generated from protobuf message c1.api.task.v1.TaskView
 */
export interface TaskView {
    /**
     * The task object being returned by the request.
     *
     * @generated from protobuf field: c1.api.task.v1.Task task = 1;
     */
    task?: Task;
    /**
     * JSONPATH expression indicating the location of the User object in the expanded array. This is the user that is a direct target of the ticket without a specific relationship to a potentially non-existent app user.
     *
     * @generated from protobuf field: string user_path = 2;
     */
    userPath: string;
    /**
     * JSONPATH expression indicating the location of the object of the User that created the ticket in the expanded array
     *
     * @generated from protobuf field: string created_by_user_path = 3;
     */
    createdByUserPath: string;
    /**
     * JSONPATH expression indicating the location of the App object in the expanded array
     *
     * @generated from protobuf field: string app_path = 4;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the Entitlements objects in the expanded array
     *
     * @generated from protobuf field: string entitlements_path = 5;
     */
    entitlementsPath: string;
    /**
     * JSONPATH expression indicating the location of the AccessReview object in the expanded array
     *
     * @generated from protobuf field: string access_review_path = 6;
     */
    accessReviewPath: string;
    /**
     * JSONPATH expression indicating the location of the AppUser object in the expanded array
     *
     * @generated from protobuf field: string app_user_path = 7;
     */
    appUserPath: string;
    /**
     * JSONPATH expression indicating the location of the StepApproverUsers objects in the expanded array
     *
     * @generated from protobuf field: string step_approvers_path = 8;
     */
    stepApproversPath: string;
    /**
     * JSONPATH expression indicating the location of the User object of the User that this task is targeting in the expanded array. This is the user that is the identity when the target of a task is an app user.
     *
     * @generated from protobuf field: string identity_user_path = 9;
     */
    identityUserPath: string;
    /**
     * JSONPATH expression indicating the location of the Insights objects in the expanded array
     *
     * @generated from protobuf field: string insights_path = 10;
     */
    insightsPath: string;
    /**
     * JSONPATH expression indicating the location of the AppUser last usage timestamp in the expanded array
     *
     * @generated from protobuf field: string app_user_last_usage_path = 11;
     */
    appUserLastUsagePath: string;
}
/**
 * This object references a task by ID.
 *
 * @generated from protobuf message c1.api.task.v1.TaskRef
 */
export interface TaskRef {
    /**
     * The ID of the referenced Task
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.GrantOrRevokeTaskRef
 */
export interface GrantOrRevokeTaskRef {
    /**
     * The ID of the referenced Task
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * A message to update the task counts.
 *
 * @generated from protobuf message c1.api.task.v1.TaskCountRefreshRef
 */
export interface TaskCountRefreshRef {
}
/**
 * A fully-fleged task object. Includes its policy, references to external apps, its type, its processing history, and more.
 *
 * @generated from protobuf message c1.api.task.v1.Task
 */
export interface Task {
    /**
     * The ID of the task.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The display name of the task.
     *
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * The description of the task. This is also known as justification.
     *
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * The ID of the user that is the target of this task. This may be empty if we're targeting a specific app user that has no known identity user.
     *
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
    /**
     * The ID of the user that is the creator of this task. This may not always match the userId field.
     *
     * @generated from protobuf field: string created_by_user_id = 5;
     */
    createdByUserId: string;
    /**
     * The current state of the task as defined by the `state_enum`
     *
     * @generated from protobuf field: c1.api.task.v1.TaskState state = 6;
     */
    state: TaskState;
    /**
     * The datetime, in RFC3339 format, of when the Task was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Task was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 18;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Task was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 19;
     */
    deletedAt?: Timestamp;
    /**
     * This is a oneOf of Task Type. Only one of TaskType's sub-properties will be non-null at a time.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskType type = 9;
     */
    type?: TaskType;
    /**
     * A fully-qualified PolicyInstance object defining the previous, current, and future processing steps of a task.
     *
     * @generated from protobuf field: c1.api.policy.v1.PolicyInstance policy = 10;
     */
    policy?: PolicyInstance;
    /**
     * The actions that can be performed on the task by the current user.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskActionType actions = 11;
     */
    actions: TaskActionType[];
    /**
     * An array of external references to the task. Historically that has been items like Jira task IDs. This is currently unused, but may come back in the future for integrations.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.ExternalRef external_refs = 12;
     */
    externalRefs: ExternalRef[];
    /**
     * An array of `google.protobuf.Any` annotations with various base64-encoded data.
     *
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 13;
     */
    annotations: Any[];
    /**
     * The ID of the analysis object associated with this task created by an analysis workflow if the analysis feature is enabled for your tenant.
     *
     * @generated from protobuf field: string analysis_id = 14;
     */
    analysisId: string;
    /**
     * An array of IDs belonging to Identity Users that are allowed to review this step in a task.
     *
     * @generated from protobuf field: repeated string step_approver_ids = 15;
     */
    stepApproverIds: string[];
    /**
     * The count of comments.
     *
     * @generated from protobuf field: int32 comment_count = 16;
     */
    commentCount: number;
    /**
     * A human-usable numeric ID of a task which can be included in place of the fully qualified task id in path parmeters (but not search queries).
     *
     * @generated from protobuf field: int64 numeric_id = 17;
     */
    numericId: number;
    /**
     * The processing state of a task as defined by the `processing_enum`
     *
     * @generated from protobuf field: c1.api.task.v1.TaskProcessingType processing = 20;
     */
    processing: TaskProcessingType;
    /**
     * A field indicating whether this task was created using an emergency access flow, or escalated to emergency access. On task creation, it will also use the app entitlement's emergency policy when possible.
     *
     * @generated from protobuf field: bool emergency_access = 21;
     */
    emergencyAccess: boolean;
    /**
     * The policy generation id refers to the current policy's generation ID. This is changed when the policy is changed on a task.
     *
     * @generated from protobuf field: string policy_generation_id = 22;
     */
    policyGenerationId: string;
    /**
     * @generated from protobuf field: repeated string insight_ids = 23;
     */
    insightIds: string[];
    /**
     * @generated from protobuf field: c1.api.task.v1.InsightRecommendation recommendation = 24;
     */
    recommendation: InsightRecommendation;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskOrigin origin = 25;
     */
    origin: TaskOrigin;
    /**
     * for custom form user input
     *
     * @generated from protobuf field: c1.api.form.v1.Form form = 26;
     */
    form?: Form;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 27;
     */
    data?: Struct;
}
/**
 * @generated from protobuf message c1.api.task.v1.ListByUserRequest
 */
export interface ListByUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.RestartTaskWorkflowRequest
 */
export interface RestartTaskWorkflowRequest {
    /**
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.RestartTaskWorkflowResponse
 */
export interface RestartTaskWorkflowResponse {
}
/**
 * @generated from protobuf enum c1.api.task.v1.ActionOutcome
 */
export enum ActionOutcome {
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: ACTION_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.OffboardingOutcome
 */
export enum OffboardingOutcome {
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_IN_PROGRESS = 1;
     */
    IN_PROGRESS = 1,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_DONE = 2;
     */
    DONE = 2,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: OFFBOARDING_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.GrantOutcome
 */
export enum GrantOutcome {
    /**
     * Unspecified task grant outcome, this is the default value.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The outcome if the grant was successful.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_GRANTED = 1;
     */
    GRANTED = 1,
    /**
     * The outcome if the grant was denied.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * The outcome if the grant encountered an error.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * The outcome if the grant was cancelled.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4,
    /**
     * The outcome if a wait step timed out.
     *
     * @generated from protobuf enum value: GRANT_OUTCOME_WAIT_TIMED_OUT = 5;
     */
    WAIT_TIMED_OUT = 5
}
/**
 * @generated from protobuf enum c1.api.task.v1.RevokeOutcome
 */
export enum RevokeOutcome {
    /**
     * Unspecified revoke outcome, this is the default outcome
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The outcome if the revoke was successful
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_REVOKED = 1;
     */
    REVOKED = 1,
    /**
     * The outcome if the revoke was denied
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * The outcome if the revoke encountered an error
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * The outcome if the revoke was cancelled
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4,
    /**
     * The outcome if a wait step timed out.
     *
     * @generated from protobuf enum value: REVOKE_OUTCOME_WAIT_TIMED_OUT = 5;
     */
    WAIT_TIMED_OUT = 5
}
/**
 * @generated from protobuf enum c1.api.task.v1.CertifyOutcome
 */
export enum CertifyOutcome {
    /**
     * Unspecified certify outcome, this is the default value.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The task was successfully certified.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_CERTIFIED = 1;
     */
    CERTIFIED = 1,
    /**
     * The certification denied, causing a decertified state. This may result in a revoke task being created or a reminder being set out, depending on the access review configurations. See (certifyRemediateImmediately).
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_DECERTIFIED = 2;
     */
    DECERTIFIED = 2,
    /**
     * An error occurred during the certification process.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * The certification request was canceled.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4,
    /**
     * The outcome if a wait step timed out.
     *
     * @generated from protobuf enum value: CERTIFY_OUTCOME_WAIT_TIMED_OUT = 5;
     */
    WAIT_TIMED_OUT = 5
}
/**
 * @generated from protobuf enum c1.api.task.v1.AccessRequestOutcome
 */
export enum AccessRequestOutcome {
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_APPROVED = 1;
     */
    APPROVED = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_DENIED = 2;
     */
    DENIED = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: ACCESS_REQUEST_OUTCOME_CANCELLED = 4;
     */
    CANCELLED = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.ExternalRefSource
 */
export enum ExternalRefSource {
    /**
     * Unspecified external reference source, this is the default value.
     *
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The external reference source was a JIRA ticket.
     *
     * @generated from protobuf enum value: JIRA = 1;
     */
    JIRA = 1
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskOrigin
 */
export enum TaskOrigin {
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_PROFILE_MEMBERSHIP_AUTOMATION = 1;
     */
    PROFILE_MEMBERSHIP_AUTOMATION = 1,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_SLACK = 2;
     */
    SLACK = 2,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_API = 3;
     */
    API = 3,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_JIRA = 4;
     */
    JIRA = 4,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_COPILOT = 5;
     */
    COPILOT = 5,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_WEBAPP = 6;
     */
    WEBAPP = 6,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_TIME_REVOKE = 7;
     */
    TIME_REVOKE = 7,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_NON_USAGE_REVOKE = 8;
     */
    NON_USAGE_REVOKE = 8,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_PROFILE_MEMBERSHIP_MANUAL = 9;
     */
    PROFILE_MEMBERSHIP_MANUAL = 9,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_PROFILE_MEMBERSHIP = 10;
     */
    PROFILE_MEMBERSHIP = 10,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_AUTOMATION = 11;
     */
    AUTOMATION = 11,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_ACCESS_REVIEW = 12;
     */
    ACCESS_REVIEW = 12,
    /**
     * @generated from protobuf enum value: TASK_ORIGIN_CASCADE_DELETE = 13;
     */
    CASCADE_DELETE = 13
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskState
 */
export enum TaskState {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: TASK_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The state of the task while it is open.
     *
     * @generated from protobuf enum value: TASK_STATE_OPEN = 1;
     */
    OPEN = 1,
    /**
     * The state of the task while it is closed.
     *
     * @generated from protobuf enum value: TASK_STATE_CLOSED = 2;
     */
    CLOSED = 2
}
/**
 * These two items are in this file because we can't have circular dependencies
 *
 * @generated from protobuf enum c1.api.task.v1.TaskActionState
 */
export enum TaskActionState {
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_DONE = 2;
     */
    DONE = 2,
    /**
     * @generated from protobuf enum value: TASK_ACTION_STATE_ERROR = 3;
     */
    ERROR = 3
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskActionType
 */
export enum TaskActionType {
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_CLOSE = 1;
     */
    CLOSE = 1,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_APPROVE = 2;
     */
    APPROVE = 2,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_DENY = 3;
     */
    DENY = 3,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_COMMENT = 4;
     */
    COMMENT = 4,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_DELETE = 5;
     */
    DELETE = 5,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_REASSIGN = 6;
     */
    REASSIGN = 6,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_RESTART = 7;
     */
    RESTART = 7,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SEND_REMINDER = 8;
     */
    SEND_REMINDER = 8,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_COMPLETE = 9;
     */
    PROVISION_COMPLETE = 9,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_CANCELLED = 10;
     */
    PROVISION_CANCELLED = 10,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_ERRORED = 11;
     */
    PROVISION_ERRORED = 11,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_ROLLBACK_SKIPPED = 12;
     */
    ROLLBACK_SKIPPED = 12,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROVISION_APP_USER_TARGET_CREATED = 13;
     */
    PROVISION_APP_USER_TARGET_CREATED = 13,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_HARD_RESET = 14;
     */
    HARD_RESET = 14,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_ESCALATE_TO_EMERGENCY_ACCESS = 15;
     */
    ESCALATE_TO_EMERGENCY_ACCESS = 15,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_CHANGE_POLICY = 16;
     */
    CHANGE_POLICY = 16,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_RECALCULATE_DENIAL_FROM_BASE_POLICY_DECISIONS = 17;
     */
    RECALCULATE_DENIAL_FROM_BASE_POLICY_DECISIONS = 17,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SET_INSIGHTS_AND_RECOMMENDATION = 18;
     */
    SET_INSIGHTS_AND_RECOMMENDATION = 18,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SET_ANALYSIS_ID = 19;
     */
    SET_ANALYSIS_ID = 19,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_RECALCULATE_APPROVERS_LIST = 20;
     */
    RECALCULATE_APPROVERS_LIST = 20,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_PROCESS_NOW = 21;
     */
    PROCESS_NOW = 21,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_APPROVE_WITH_STEP_UP = 22;
     */
    APPROVE_WITH_STEP_UP = 22,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_SKIP_STEP = 23;
     */
    SKIP_STEP = 23,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_ROLLBACK_CANCELLED = 24;
     */
    ROLLBACK_CANCELLED = 24,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_UPDATE_REQUEST_DATA = 25;
     */
    UPDATE_REQUEST_DATA = 25,
    /**
     * @generated from protobuf enum value: TASK_ACTION_TYPE_UPDATE_GRANT_DURATION = 26;
     */
    UPDATE_GRANT_DURATION = 26
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskProcessingType
 */
export enum TaskProcessingType {
    /**
     * Base state for when the data is not sent properly. Should be considered invalid.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * A calculated field based on task states for when a task is processing.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_PROCESSING = 1;
     */
    PROCESSING = 1,
    /**
     * A calculated field based on task states for when a task is waiting for input.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_WAITING = 2;
     */
    WAITING = 2,
    /**
     * A calculated field based on task states for when a task has finished processing.
     *
     * @generated from protobuf enum value: TASK_PROCESSING_TYPE_DONE = 3;
     */
    DONE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskExpandMask$Type extends MessageType<TaskExpandMask> {
    constructor() {
        super("c1.api.task.v1.TaskExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "access_review_id", "user_id", "created_by_user_id", "app_id", "app_user_id", "app_entitlement_ids", "step_approver_ids", "identity_user_id", "insight_ids", "app_user_last_usage"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskExpandMask
 */
export const TaskExpandMask = new TaskExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetRequest$Type extends MessageType<TaskServiceGetRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27})|([0-9]+)$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetRequest
 */
export const TaskServiceGetRequest = new TaskServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetResponse$Type extends MessageType<TaskServiceGetResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetResponse
 */
export const TaskServiceGetResponse = new TaskServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateGrantResponse$Type extends MessageType<TaskServiceCreateGrantResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateGrantResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateGrantResponse
 */
export const TaskServiceCreateGrantResponse = new TaskServiceCreateGrantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateRevokeResponse$Type extends MessageType<TaskServiceCreateRevokeResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateRevokeResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateRevokeResponse
 */
export const TaskServiceCreateRevokeResponse = new TaskServiceCreateRevokeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateOffboardingResponse$Type extends MessageType<TaskServiceCreateOffboardingResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateOffboardingResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateOffboardingResponse
 */
export const TaskServiceCreateOffboardingResponse = new TaskServiceCreateOffboardingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateActionRequest$Type extends MessageType<TaskServiceCreateActionRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateActionRequest", [
            { no: 1, name: "action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "form_values", kind: "message", T: () => Struct },
            { no: 4, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateActionRequest
 */
export const TaskServiceCreateActionRequest = new TaskServiceCreateActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateActionResponse$Type extends MessageType<TaskServiceCreateActionResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateActionResponse", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateActionResponse
 */
export const TaskServiceCreateActionResponse = new TaskServiceCreateActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceListRequest$Type extends MessageType<TaskServiceListRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceListRequest
 */
export const TaskServiceListRequest = new TaskServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceListResponse$Type extends MessageType<TaskServiceListResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceListResponse
 */
export const TaskServiceListResponse = new TaskServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceUpdateRequest$Type extends MessageType<TaskServiceUpdateRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceUpdateRequest", [
            { no: 1, name: "task", kind: "message", T: () => Task, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceUpdateRequest
 */
export const TaskServiceUpdateRequest = new TaskServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateRevokeRequest$Type extends MessageType<TaskServiceCreateRevokeRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateRevokeRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 6, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateRevokeRequest
 */
export const TaskServiceCreateRevokeRequest = new TaskServiceCreateRevokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateGrantRequest$Type extends MessageType<TaskServiceCreateGrantRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateGrantRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 7, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "grant_duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { gt: {} } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 8, name: "emergency_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "source", kind: "message", T: () => TaskGrantSource },
            { no: 10, name: "request_data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateGrantRequest
 */
export const TaskServiceCreateGrantRequest = new TaskServiceCreateGrantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateManyGrantTasksRequest$Type extends MessageType<TaskServiceCreateManyGrantTasksRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "grant_duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { gt: {} } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 7, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 8, name: "source", kind: "message", T: () => TaskGrantSource },
            { no: 9, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 10, name: "request_data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateManyGrantTasksRequest
 */
export const TaskServiceCreateManyGrantTasksRequest = new TaskServiceCreateManyGrantTasksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateOffboardingRequest$Type extends MessageType<TaskServiceCreateOffboardingRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateOffboardingRequest", [
            { no: 1, name: "subject_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateOffboardingRequest
 */
export const TaskServiceCreateOffboardingRequest = new TaskServiceCreateOffboardingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceCreateRequest$Type extends MessageType<TaskServiceCreateRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 5, name: "typ", kind: "message", T: () => TaskType },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 9, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 10, name: "emergency_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceCreateRequest
 */
export const TaskServiceCreateRequest = new TaskServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceDeleteRequest$Type extends MessageType<TaskServiceDeleteRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceDeleteRequest
 */
export const TaskServiceDeleteRequest = new TaskServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskApprovers$Type extends MessageType<TaskApprovers> {
    constructor() {
        super("c1.api.task.v1.TaskApprovers", [
            { no: 1, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskApprovers
 */
export const TaskApprovers = new TaskApprovers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetSendReminderPreviewRequest$Type extends MessageType<TaskServiceGetSendReminderPreviewRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewRequest
 */
export const TaskServiceGetSendReminderPreviewRequest = new TaskServiceGetSendReminderPreviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceGetSendReminderPreviewResponse$Type extends MessageType<TaskServiceGetSendReminderPreviewResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse", [
            { no: 1, name: "task_approvers", kind: "message", T: () => TaskApprovers }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceGetSendReminderPreviewResponse
 */
export const TaskServiceGetSendReminderPreviewResponse = new TaskServiceGetSendReminderPreviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceSendReminderRequest$Type extends MessageType<TaskServiceSendReminderRequest> {
    constructor() {
        super("c1.api.task.v1.TaskServiceSendReminderRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "copy_managers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "copied_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceSendReminderRequest
 */
export const TaskServiceSendReminderRequest = new TaskServiceSendReminderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFormDataServiceGetByTaskIdRequest$Type extends MessageType<ResolvedFormDataServiceGetByTaskIdRequest> {
    constructor() {
        super("c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27})|([0-9]+)$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdRequest
 */
export const ResolvedFormDataServiceGetByTaskIdRequest = new ResolvedFormDataServiceGetByTaskIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFormDataServiceGetByTaskIdResponse$Type extends MessageType<ResolvedFormDataServiceGetByTaskIdResponse> {
    constructor() {
        super("c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse", [
            { no: 1, name: "resolved_form_data", kind: "message", T: () => ResolvedFormData, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ResolvedFormDataServiceGetByTaskIdResponse
 */
export const ResolvedFormDataServiceGetByTaskIdResponse = new ResolvedFormDataServiceGetByTaskIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolvedFormData$Type extends MessageType<ResolvedFormData> {
    constructor() {
        super("c1.api.task.v1.ResolvedFormData", [
            { no: 1, name: "form", kind: "message", T: () => Form, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "resolved_values", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ResolvedFormData
 */
export const ResolvedFormData = new ResolvedFormData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceSendReminderResponse$Type extends MessageType<TaskServiceSendReminderResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceSendReminderResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceSendReminderResponse
 */
export const TaskServiceSendReminderResponse = new TaskServiceSendReminderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskServiceDeleteResponse$Type extends MessageType<TaskServiceDeleteResponse> {
    constructor() {
        super("c1.api.task.v1.TaskServiceDeleteResponse", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskServiceDeleteResponse
 */
export const TaskServiceDeleteResponse = new TaskServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskType$Type extends MessageType<TaskType> {
    constructor() {
        super("c1.api.task.v1.TaskType", [
            { no: 1, name: "grant", kind: "message", oneof: "taskType", T: () => TaskTypeGrant },
            { no: 2, name: "revoke", kind: "message", oneof: "taskType", T: () => TaskTypeRevoke },
            { no: 3, name: "certify", kind: "message", oneof: "taskType", T: () => TaskTypeCertify },
            { no: 4, name: "offboarding", kind: "message", oneof: "taskType", T: () => TaskTypeOffboarding },
            { no: 5, name: "action", kind: "message", oneof: "taskType", T: () => TaskTypeAction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskType
 */
export const TaskType = new TaskType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeAction$Type extends MessageType<TaskTypeAction> {
    constructor() {
        super("c1.api.task.v1.TaskTypeAction", [
            { no: 1, name: "action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "form_values", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.ActionOutcome", ActionOutcome, "ACTION_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeAction
 */
export const TaskTypeAction = new TaskTypeAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeOffboarding$Type extends MessageType<TaskTypeOffboarding> {
    constructor() {
        super("c1.api.task.v1.TaskTypeOffboarding", [
            { no: 1, name: "subject_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.OffboardingOutcome", OffboardingOutcome, "OFFBOARDING_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeOffboarding
 */
export const TaskTypeOffboarding = new TaskTypeOffboarding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeGrant$Type extends MessageType<TaskTypeGrant> {
    constructor() {
        super("c1.api.task.v1.TaskTypeGrant", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "grant_duration", kind: "message", T: () => Duration, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.GrantOutcome", GrantOutcome, "GRANT_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "source", kind: "message", T: () => TaskGrantSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeGrant
 */
export const TaskTypeGrant = new TaskTypeGrant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskGrantSource$Type extends MessageType<TaskGrantSource> {
    constructor() {
        super("c1.api.task.v1.TaskGrantSource", [
            { no: 1, name: "integration_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "external_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_extension", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskGrantSource
 */
export const TaskGrantSource = new TaskGrantSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceReview$Type extends MessageType<TaskRevokeSourceReview> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceReview", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cert_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceReview
 */
export const TaskRevokeSourceReview = new TaskRevokeSourceReview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceRequest$Type extends MessageType<TaskRevokeSourceRequest> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceRequest", [
            { no: 1, name: "request_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceRequest
 */
export const TaskRevokeSourceRequest = new TaskRevokeSourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceExpired$Type extends MessageType<TaskRevokeSourceExpired> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceExpired", [
            { no: 1, name: "expired_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceExpired
 */
export const TaskRevokeSourceExpired = new TaskRevokeSourceExpired$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSourceNonUsage$Type extends MessageType<TaskRevokeSourceNonUsage> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSourceNonUsage", [
            { no: 1, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "last_login", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSourceNonUsage
 */
export const TaskRevokeSourceNonUsage = new TaskRevokeSourceNonUsage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRevokeSource$Type extends MessageType<TaskRevokeSource> {
    constructor() {
        super("c1.api.task.v1.TaskRevokeSource", [
            { no: 1, name: "review", kind: "message", oneof: "origin", T: () => TaskRevokeSourceReview },
            { no: 2, name: "request", kind: "message", oneof: "origin", T: () => TaskRevokeSourceRequest },
            { no: 3, name: "expired", kind: "message", oneof: "origin", T: () => TaskRevokeSourceExpired },
            { no: 4, name: "non_usage", kind: "message", oneof: "origin", T: () => TaskRevokeSourceNonUsage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRevokeSource
 */
export const TaskRevokeSource = new TaskRevokeSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeRevoke$Type extends MessageType<TaskTypeRevoke> {
    constructor() {
        super("c1.api.task.v1.TaskTypeRevoke", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.RevokeOutcome", RevokeOutcome, "REVOKE_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "source", kind: "message", T: () => TaskRevokeSource, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeRevoke
 */
export const TaskTypeRevoke = new TaskTypeRevoke$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskTypeCertify$Type extends MessageType<TaskTypeCertify> {
    constructor() {
        super("c1.api.task.v1.TaskTypeCertify", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "access_review_selection", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "outcome", kind: "enum", T: () => ["c1.api.task.v1.CertifyOutcome", CertifyOutcome, "CERTIFY_OUTCOME_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "outcome_time", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskTypeCertify
 */
export const TaskTypeCertify = new TaskTypeCertify$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalRef$Type extends MessageType<ExternalRef> {
    constructor() {
        super("c1.api.task.v1.ExternalRef", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "external_ref_source", kind: "enum", T: () => ["c1.api.task.v1.ExternalRefSource", ExternalRefSource], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ExternalRef
 */
export const ExternalRef = new ExternalRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskWebhookPayload$Type extends MessageType<TaskWebhookPayload> {
    constructor() {
        super("c1.api.task.v1.TaskWebhookPayload", [
            { no: 1, name: "task_view", kind: "message", T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskWebhookPayload
 */
export const TaskWebhookPayload = new TaskWebhookPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskView$Type extends MessageType<TaskView> {
    constructor() {
        super("c1.api.task.v1.TaskView", [
            { no: 1, name: "task", kind: "message", T: () => Task, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_by_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "entitlements_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "access_review_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "step_approvers_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "insights_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "app_user_last_usage_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskView
 */
export const TaskView = new TaskView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskRef$Type extends MessageType<TaskRef> {
    constructor() {
        super("c1.api.task.v1.TaskRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskRef
 */
export const TaskRef = new TaskRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantOrRevokeTaskRef$Type extends MessageType<GrantOrRevokeTaskRef> {
    constructor() {
        super("c1.api.task.v1.GrantOrRevokeTaskRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GrantOrRevokeTaskRef
 */
export const GrantOrRevokeTaskRef = new GrantOrRevokeTaskRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskCountRefreshRef$Type extends MessageType<TaskCountRefreshRef> {
    constructor() {
        super("c1.api.task.v1.TaskCountRefreshRef", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskCountRefreshRef
 */
export const TaskCountRefreshRef = new TaskCountRefreshRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Task$Type extends MessageType<Task> {
    constructor() {
        super("c1.api.task.v1.Task", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "created_by_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "state", kind: "enum", T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 18, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 19, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "type", kind: "message", T: () => TaskType, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "policy", kind: "message", T: () => PolicyInstance, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "actions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.TaskActionType", TaskActionType, "TASK_ACTION_TYPE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "external_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExternalRef, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "analysis_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "step_approver_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 16, name: "comment_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 17, name: "numeric_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 20, name: "processing", kind: "enum", T: () => ["c1.api.task.v1.TaskProcessingType", TaskProcessingType, "TASK_PROCESSING_TYPE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 21, name: "emergency_access", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 22, name: "policy_generation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 23, name: "insight_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "recommendation", kind: "enum", T: () => ["c1.api.task.v1.InsightRecommendation", InsightRecommendation, "INSIGHT_RECOMMENDATION_"] },
            { no: 25, name: "origin", kind: "enum", T: () => ["c1.api.task.v1.TaskOrigin", TaskOrigin, "TASK_ORIGIN_"] },
            { no: 26, name: "form", kind: "message", T: () => Form, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 27, name: "data", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.Task
 */
export const Task = new Task$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListByUserRequest$Type extends MessageType<ListByUserRequest> {
    constructor() {
        super("c1.api.task.v1.ListByUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListByUserRequest
 */
export const ListByUserRequest = new ListByUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestartTaskWorkflowRequest$Type extends MessageType<RestartTaskWorkflowRequest> {
    constructor() {
        super("c1.api.task.v1.RestartTaskWorkflowRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RestartTaskWorkflowRequest
 */
export const RestartTaskWorkflowRequest = new RestartTaskWorkflowRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestartTaskWorkflowResponse$Type extends MessageType<RestartTaskWorkflowResponse> {
    constructor() {
        super("c1.api.task.v1.RestartTaskWorkflowResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RestartTaskWorkflowResponse
 */
export const RestartTaskWorkflowResponse = new RestartTaskWorkflowResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskService
 */
export const TaskService = new ServiceType("c1.api.task.v1.TaskService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/tasks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Task", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Task" }] } }, I: TaskServiceGetRequest, O: TaskServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateRequest, O: TaskServiceGetResponse },
    { name: "CreateRevokeTask", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/revoke", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "TaskRevoke" }], group: "Task" }] } }, I: TaskServiceCreateRevokeRequest, O: TaskServiceCreateRevokeResponse },
    { name: "CreateGrantTask", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/grant", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "TaskGrant" }], group: "Task" }] } }, I: TaskServiceCreateGrantRequest, O: TaskServiceCreateGrantResponse },
    { name: "CreateManyGrantTasks", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateManyGrantTasksRequest, O: TaskServiceListResponse },
    { name: "CreateOffboardingTask", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/task/offboarding", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "TaskOffboarding" }], group: "Task" }] } }, I: TaskServiceCreateOffboardingRequest, O: TaskServiceCreateOffboardingResponse },
    { name: "CreateActionTask", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceCreateActionRequest, O: TaskServiceCreateActionResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceUpdateRequest, O: TaskServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: TaskServiceListRequest, O: TaskServiceListResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" } }, I: TaskServiceDeleteRequest, O: TaskServiceDeleteResponse },
    { name: "GetSendReminderPreview", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceGetSendReminderPreviewRequest, O: TaskServiceGetSendReminderPreviewResponse },
    { name: "SendReminder", options: { "authz.method": { role: "EDITOR" } }, I: TaskServiceSendReminderRequest, O: TaskServiceSendReminderResponse },
    { name: "GetByTaskId", options: { "authz.method": { role: "VIEWER" } }, I: ResolvedFormDataServiceGetByTaskIdRequest, O: ResolvedFormDataServiceGetByTaskIdResponse }
]);
